import { Box } from "@mui/material";
import React, { useState } from "react";
import CustomizedHook from "../../project/autocomplatePro";
import { InputCreateProject } from "../../project/createProjectPop";
import DatePicker from "../../project/datePicker";
import mapPointer from "../../../assets/image/mapPointer.png";
import { useEffect } from "react";
import {
  getCities,
  getCountries,
  getStates,
  putRunInfo,
} from "../../../api/area";
import ClockArea from "./clockArea";
import MapIran from "./mapIran";
// import { TimeClock } from '@mui/x-date-pickers/TimeClock';

export default function LevelOneArea({
  level,
  setLevel,
  stepOne,
  setStepOne,
  setDataLoc,
  dataLoc,
  areaId,
  update,
  date,
  setDate,
}) {
  const [showDatePicker, setShowDatePicker] = useState();
  const [showClock, setShowClock] = useState();
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [clockTime, setClockTime] = useState();
  const [clockTimeEnd, setClockTimeEnd] = useState();

  useEffect(() => {
    getCountries()
      .then((x) => setCountries(x))
      .catch(() => {});
  }, []);
  useEffect(() => {
    if (stepOne.countryId) {
      getStates(stepOne.countryId)
        .then((x) => {
          setStates(x);
        })
        .catch(() => {});
    }
  }, [stepOne]);
  useEffect(() => {
    if (stepOne?.stateId) {
      getCities(stepOne?.stateId)
        .then((x) => {
          setCities(x);
        })
        .catch(() => {});
    }
  }, [stepOne]);

  useEffect(() => {
    if (date?.length === 1) {
      setStepOne({ ...stepOne, startAt: date[0]?.toUnix() * 1000 });
    }
    if (date?.length === 2) {
      setStepOne({ ...stepOne, endAt: date[1]?.toUnix() * 1000 });
    }
  }, [date]);
  useEffect(() => {
    if (clockTime) {
      setStepOne({ ...stepOne, dailyStartAt: clockTime });
    }
  }, [clockTime]);
  useEffect(() => {
    if (clockTimeEnd) {
      setStepOne({ ...stepOne, dailyEndAt: clockTimeEnd });
    }
  }, [clockTimeEnd]);
  // console.log(clockTime);
  // console.log(clockTimeEnd);
  // console.log(dataLoc?.cities?.name);
  return (
    <>
      <DatePicker
        sx={{ marginLeft: "-30px !important" }}
        date={date}
        setDate={setDate}
        show={showDatePicker}
        setShow={setShowDatePicker}
      />
      <ClockArea
        date={clockTime}
        setDate={setClockTime}
        dateEnd={clockTimeEnd}
        setDateEnd={setClockTimeEnd}
        show={showClock}
        setShow={setShowClock}
      />
      <Box
        mt="20px"
        gap="10px"
        display="flex"
        flexWrap={"wrap"}
        justifyContent="space-around"
      >
        <CustomizedHook
          multiple
          width={"30vw"}
          placeholder={"انتخاب کنید."}
          label="کشور"
          options={countries}
          onChange={(event, newValue) => {
            getStates(newValue.id)
              .then((x) => {
                setStates(x);
                setDataLoc({ ...dataLoc, countries: newValue });
              })
              .catch(() => {});
          }}
          value={
            dataLoc?.countries?.name !== ""
              ? dataLoc?.countries
              : countries.find((country) => country.name === stepOne.country) ||
                null
          }
        />
        <CustomizedHook
          multiple
          width={"30vw"}
          placeholder={"انتخاب کنید."}
          label="استان"
          options={states}
          onChange={(event, newValue) => {
            if (newValue) {
              getCities(newValue.id)
                .then((x) => {
                  setCities(x);
                  setDataLoc({ ...dataLoc, states: newValue });
                })
                .catch(() => {});
            }
          }}
          value={
            dataLoc?.states?.name !== ""
              ? dataLoc?.states
              : states.find((state) => state.name === stepOne.state) || null
          }
        />
        <CustomizedHook
          multiple
          width={"30vw"}
          placeholder={"انتخاب کنید."}
          label="شهر"
          options={cities}
          onChange={(event, newValue) => {
            setStepOne({ ...stepOne, cityId: newValue.id });
            setDataLoc({ ...dataLoc, cities: newValue });
          }}
          value={
            dataLoc?.cities?.name !== ""
              ? dataLoc?.cities
              : cities.find((city) => city.name === stepOne.city) || null
          }
        />
        <Box display="flex" width="31vw">
          <InputCreateProject
            width="90%"
            onClick={(e) => {
              setShowDatePicker(e.currentTarget);
            }}
            value={
              date?.length >= 2
                ? `${date[0].year}/${date[0].month}/${date[0].day} تا ${date[1].year}/${date[1].month}/${date[1].day} `
                : date?.length >= 1
                ? `${date[0].day}/${date[0].month}/${date[0].year}`
                : //   : defData
                //   ? `${defData?.startAt.split(" ", 1)} - ${defData?.endAt.split(
                //       " ",
                //       1
                //     )}`
                stepOne?.endAt
                ? `${stepOne?.startAt?.split("-", 1)[0]} تا ${
                    stepOne?.endAt?.split("-", 1)[0]
                  }`
                : ""
            }
            placeholder={"زمان شروع و پایان اردو"}
            label="بازه زمانی اردو"
          />
          {update ? (
            <InputCreateProject
              width="70%"
              mr="15px"
              placeholder={"زمان شروع و پایان."}
              label="ساعت"
              onClick={(e) => {
                setShowClock(e.currentTarget);
              }}
              value={
                clockTime
                  ? +" " + "تا" + " " + clockTimeEnd
                  : stepOne?.dailyStartAt
                  ? `${stepOne?.dailyStartAt} تا ${stepOne?.dailyEndAt} `
                  : stepOne?.endAt
                  ? `${stepOne?.startAt?.split("-", 2)[1]} تا ${
                      stepOne?.endAt?.split("-", 2)[1]
                    }`
                  : ""
              }
              //   onChange={(e) => setTripName(e.target.value)}
            />
          ) : (
            <InputCreateProject
              width="70%"
              mr="15px"
              placeholder={"زمان شروع و پایان."}
              label="ساعت"
              onClick={(e) => {
                setShowClock(e.currentTarget);
              }}
              value={
                clockTime ? clockTime + " " + "تا" + " " + clockTimeEnd : ""
              }
              //   onChange={(e) => setTripName(e.target.value)}
            />
          )}
        </Box>
        <Box
          width="100%"
          mt="15px"
          height="38vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bgcolor="#D9D9D9"
          borderRadius={"13px"}
          sx={{ overflow: "hidden" }}
        >
          <MapIran stepOne={stepOne} setStepOne={setStepOne} />
        </Box>
        <button
          onClick={() => {
            // if (stepOne?.countryId || date?.length >= 2) {
            // if (date?.length >= 2) {
            putRunInfo(areaId, stepOne)
              .then(() => {
                setLevel(2);
                localStorage.setItem("levelPopArea", JSON.stringify(2));
              })
              .catch(() => {});
            // }
            // if (stepOne?.countryId) {
            //   setLevel(2);
            // }
            // }
            // setLevel(2);
            // console.log(stepOne);
          }}
          style={
            stepOne?.countryId || date?.length >= 2
              ? {}
              : { opacity: "0.5", cursor: "no-drop" }
          }
          className="btnCreate"
        >
          {"مرحله بعدی"}
        </button>
      </Box>
    </>
  );
}
